<template>
  <v-container class="intake-form-page no-padding-mobile" fluid>
    <v-row
      justify="center"
      class="mx-4"
      :style="$vuetify.breakpoint.xs ? 'margin-left: 0 !important;margin-right: 0 !important; margin-top:30px' : ''"
    >
      <v-col cols="12" lg="12" xl="11" class="no-padding-mobile">
        <v-card class="elevation-2 card-empty" color="primary">
          <v-list-item one-line class="pt-1">
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 mb-1 white--text text--darken-2 font-weight-bold">
                <v-icon left color="white">mdi-calendar-month</v-icon>
                {{ translate($store.getters.content.appointments_calendar) }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="bg-white text-area pa-0" v-if="location != null">
            <AppoinmentsCalendar :location="location" v-if="loadCalendar" />
          </v-card-text>
          <v-card-text class="bg-white text-area pa-20" v-else>
            <p>{{ translate($store.getters.content.select_location) }}</p>
            <v-col class="d-flex" cols="12" sm="6" offset-md="3">
              <div v-if="locations.length > 0" class="mx-auto">
                <!-- <v-select :items="locations" item-text="name" item-value="id" label="Locations" v-model="selectedLocation" outlined></v-select> -->
                <template>
                  <v-select
                    :label="translate($store.getters.content.locations)"
                    :items="locations"
                    item-text="name"
                    item-value="id"
                    return-object
                    :rules="[(v) => !!v || translate($store.getters.content.required_location)]"
                    v-model="selectedLocation"
                    persistent-hint
                    outlined
                  >
                    <template slot="item" slot-scope="{ item }">
                      <v-list-item-content class="py-2">
                        <v-list-item-content v-text="item.name" class="pb-1"></v-list-item-content>
                        <v-list-item-subtitle v-html="item.address" class="mt-0"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
              </div>
              <div class="mx-auto" v-else>
                <v-skeleton-loader type="text" width="200" height="60"></v-skeleton-loader>
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <div class="nav-btns mt-8">
                <div class="spacer"></div>
                <!-- <div class="right-buttons"> -->
                <v-btn color="primary" @click="back()" text large>
                  <v-icon class="ma-0" left>mdi-chevron-left</v-icon>
                  {{ translate($store.getters.content.back) }}
                </v-btn>
                <!-- <v-btn color="primary" @click="checkLocation()" large class="ms-4" :disabled="selectedLocation == '' || selectedLocation == null">
                    {{ translate($store.getters.content.next) }}
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn> -->
              </div>
              <!-- </div> -->
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import AppoinmentsCalendar from '@/views/AppointmentsCalendarPage/components/appoinments-calendar.vue';
import moment from 'moment';

export default {
  mixins: [SharedFunctions],
  components: {
    AppoinmentsCalendar,
  },
  data() {
    return {
      selectedLocation: null,
      loadCalendar: false,
    };
  },
  watch: {
    location(value) {
      if (value != '') this.checkLocation();
    },
    selectedLocation(value) {
      if (value != '') this.checkLocation();
    },
  },
  computed: {
    minDate() {
      const now = new Date();
      const date = moment(now).format('YYYY-MM-DD');
      return date;
    },
    maxDate() {
      const date = new Date(); //today
      // var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      date.setDate(date.getDate() + 45);
      const maxDate = moment(date).format('YYYY-MM-DD');
      // const maxDate = moment(lastDayOfMonth).format('YYYY-MM-DD');
      return maxDate;
    },
    locations: {
      get() {
        return this.$store.getters.locations;
      },
      set(value) {
        this.$store.commit('SET_LOCATIONS', value);
      },
    },
    location() {
      return this.$route.params.location;
    },
    code() {
      return this.$store.state.intakeFormData.code;
    },
  },
  created() {
    this.locations = [];
    if (this.locations.length <= 0 && this.code != null) {
      this.getLocations();
    }
  },
  mounted() {
    this.checkAppointmentCode();
    if (this.location != null && this.code != null) this.getCalendarEntries();
  },
  methods: {
    async getCalendarEntries() {
      // let event;
      // if (this.$store.getters.currentCalendarRange) {
      //   event = this.$store.getters.currentCalendarRange;
      // } else return null;

      if (this.location == null || this.code == null) {
        return;
      }

      this.loadCalendar = true;
      this.$store.commit('SET_CURRENT_CALENDAR_LOADER', true);
      this.$store
        .dispatch('GET_CALENDAR_ENTRIES', {
          // minDate: event.start.date,
          // maxDate: event.end.date
          minDate: this.minDate,
          maxDate: this.maxDate,
          location: this.location,
          code: this.code.code,
        })
        .then((data) => {
          this.$store.commit('SET_CURRENT_CALENDAR_LOADER', false);
          let events = [];
          const eventsAvailable = this.createCalendarEventsArray(data, 'AVAILABLE_COUNT', 'slots open', 'success');
          // const eventsResevedApp = this.createCalendarEventsArray(data, 'RESERVED_APP_COUNT', 'slots reserved app', 'primary');
          // const eventsResevedDashboard = this.createCalendarEventsArray(data, 'RESERVED_DASHBOARD_COUNT', 'slots reserved dashboard', 'secondary');
          if (eventsAvailable.length > 0) events = events.concat(eventsAvailable);
          // if (eventsResevedApp.length > 0) events = events.concat(eventsResevedApp);
          // if (eventsResevedDashboard.length > 0) events = events.concat(eventsResevedDashboard);

          this.$store.commit('SET_CURRENT_CALENDAR_EVENTS', events);
        });
    },
    createCalendarEventsArray(data, type, text, color) {
      let events = data
        //filters all event types that have a zero count
        .filter((event) => {
          return event[type] > 0;
        })
        .map((event) => {
          return {
            name: event[type] + ' ' + text,
            start: event.date,
            color: color,
          };
        });

      return events;
    },
    getLocations() {
      this.$store
        .dispatch('GET_LOCATIONS', {
          code: this.code.code,
        })
        .then((data) => {
          if (data) {
            this.$store.commit('SET_LOCATIONS', data);
          }
        });
    },
    selectLocation($event) {
      if ($event != '') {
        this.location = $event;
      }
    },
    checkLocation() {
      if (this.selectedLocation != '') {
        //this.$store.commit('SET_LOCATION', this.location);
        this.$router.push(`/appointments/${this.selectedLocation.id}`);
        this.getCalendarEntries();
      }
    },
    back() {
      //this.$store.commit('SET_LOCATION', null);
      //this.$router.push({ name: 'Home' });
      this.$router.go(-1);
    },
    checkAppointmentCode() {
      if (this.code == null || this.code == undefined) {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss">
.v-list-item__title {
  //text-transform: uppercase;
}
.nav-btns {
  display: block;
  height: 40px;
}
.right-buttons {
  float: right;
}
.v-skeleton-loader {
  .v-skeleton-loader__text {
    height: 60px;
  }
}
</style>
